var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferBp = function SvgTransferBp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TransferBP_svg__a)",
    fill: "#305992"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22.5h20v15h-3.75V26.25H37.5V22.5Zm-11.25 15v16.25H37.5v3.75h-15v-20h3.75ZM15 35V15h20v20H15Zm25 30V40h25v25H40Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TransferBP_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 15)",
    d: "M0 0h50v50H0z"
  })))));
};
export default SvgTransferBp;